import { Box } from "@mui/material"
import { Appbar, Footer } from "../components"
import './styles.css'

export const LoginLayout = ({children}) => {
    return (
        <div className="scale-up-ver-center">
            <Appbar />

            <Box sx={{ backgroundImage: 'url(/fondo-login.png)', backgroundSize: '100% auto', backgroundPosition: 'center', width: '100vw', height: 'calc(100vh - 120px)', minHeight:'450px' }} >

                {children}

            </Box>

            <Footer />
        </div>
    )
}
